import React from 'react';
import CarouselNavigation from '../Common/CarouselNavigation';
import ModalCloseButton from '../Common/ModalCloseButton';

const VehicleModal = ({ selectedVehicle, vehicles, onClose, onNavigate }) => {
  if (!selectedVehicle) return null;

  const currentIndex = vehicles.findIndex(
    (vehicle) => vehicle.id === selectedVehicle.id
  );
  const hasPrevious = vehicles.length > 1;
  const hasNext = vehicles.length > 1;

  const handlePrevious = (e) => {
    e.stopPropagation();
    const prevIndex = (currentIndex - 1 + vehicles.length) % vehicles.length;
    onNavigate(vehicles[prevIndex]);
  };

  const handleNext = (e) => {
    e.stopPropagation();
    const nextIndex = (currentIndex + 1) % vehicles.length;
    onNavigate(vehicles[nextIndex]);
  };

  return (
    <div
      className="vehicle-modal"
      onClick={(e) => {
        if (e.target.classList.contains("vehicle-modal")) {
          onClose();
        }
      }}
    >
      <div className="modal-content">
        <ModalCloseButton onClick={onClose} />
        
        <CarouselNavigation
          onPrevious={handlePrevious}
          onNext={handleNext}
          hasPrevious={hasPrevious}
          hasNext={hasNext}
        />

        <div className="modal-banner">
          <img
            src={selectedVehicle.images[0]}
            alt={selectedVehicle.title}
            onError={(e) => (e.target.src = "/img/datlogoA.png")}
          />
          <div className="modal-title-overlay top-centered">
            {selectedVehicle.title}
          </div>
        </div>

        <div className="modal-details">
          <p className="modal-description">{selectedVehicle.description}</p>
          <div className="modal-gallery-wrapper">
            <div className="modal-gallery">
              {selectedVehicle.images.slice(1).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`${selectedVehicle.title} ${index + 1}`}
                  onError={(e) => (e.target.src = "/img/datlogoA.png")}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleModal;
